<template>
	<div class="bb-panel-wrapper">
		<div class="loading-campaign" v-if="campaignItemMediasLoading">
			<loading-icon></loading-icon>
		</div>
		<span class="b360-form-label" role="heading"
			>Select {{ selectContent }} Template</span
		>
		<section class="design-column">
			<!-- TODO: Change - forcing template for pricing flyer when selectContentArray is empty -->
			<section
				v-if="
					selectedMediaType === MEDIA_ID.PRICING_FLYER &&
					!selectContentArray.length
				"
			>
				<div tabindex="0" class="design selected" role="button">
					<div class="b360-fake-img-border"></div>
					<img
						src="https://res.cloudinary.com/uwm/image/upload/v1570132773/templates/PRICING_LAYOUT_1.png"
						class="b360-large-image-radio"
					/>
					<Radio
						radioId="select-card-0"
						radioGroupName="designGroup"
						:isChecked="true"
						radioDescription="media group radio"
					/>
				</div>
			</section>
			<section
				v-if="
					selectedMediaType !== MEDIA_ID.POWERPOINT &&
					selectedMediaType !== MEDIA_ID.VIDEO
				"
			>
				<BBDesignCard
					v-for="(card, index) in selectContentArray"
					:key="index"
					:card="card"
					@click.native="selectCard(card, index)"
					@keydown.enter="selectCard(card, index)"
					:radioKey="card.template.name"
					:selected="
						card.item.campaignItemId === selectedDesign.item.campaignItemId &&
						card.template.html === selectedDesign.template.html
					"
				/>
			</section>
			<section v-if="selectedMediaType === MEDIA_ID.VIDEO">
				<BBDesignCard
					v-for="(card, index) in selectedDesignCampaignItem"
					:key="index"
					:card="card"
					@click.native="selectCard(card, index)"
					@keydown.enter="selectCard(card, index)"
					:radioKey="card.mediaId"
					:selected="index === selectedDesignIndex"
				/>
			</section>
			<div v-if="selectedMediaType === MEDIA_ID.POWERPOINT">
				<BBPresentationDesignCard
					v-for="(card, index) in selectContentArray"
					:key="index"
					:card="card"
					@click.native="selectCard(card, index)"
					@keydown.enter="selectCard(card, index)"
					:radioKey="card.index"
					:selected="
						card.item === selectedDesign.item &&
						card.template === selectedDesign.template
					"
				/>
			</div>
		</section>
		<button class="b360-btn b360-btn--workspace-primary" @click="nextStep()">
			Next Step
		</button>
	</div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import BBDesignCard from '@/components/brand-builder/bb-design/BBDesignCard.vue';
import BBPresentationDesignCard from '@/components/brand-builder/bb-design/BBPresentationDesignCard.vue';
import Radio from '@/components/global/Radio.vue';
import { MEDIA_ID, AUDIENCE_ID } from '@/constants/brand-builder';
import LoadingIcon from '@/components/global/LoadingIcon.vue';

export default {
	name: 'BbDesign',
	components: {
		BBDesignCard,
		BBPresentationDesignCard,
		Radio,
		LoadingIcon,
	},
	data() {
		return {
			MEDIA_ID,
		};
	},
	computed: {
		...mapState({
			selectedDesign: (state) => {
				if (state.brandBuilderEditor.selectedDesign) {
					return state.brandBuilderEditor.selectedDesign;
				}
				return '';
			},
			selectedMediaType: (state) => state.brandBuilderEditor.selectedMediaType,
			selectContent: (state) =>
				state.brandBuilderEditor.mediaTypeArray.filter(
					(x) => x.index === state.brandBuilderEditor.selectedMediaType,
				).typeName,
			selectContentArray: (state) =>
				state.brandBuilderEditor.filteredItems
					.map((x) => x.templates.map((y) => ({ item: x, template: y })))
					.flat(),
			selectedDesignIndex: (state) =>
				state.brandBuilderEditor.selectedDesignIndex,
			selectedAudienceType: (state) =>
				state.brandBuilderEditor.selectedAudienceType,
			campaignItemMediasLoading: (state) =>
				state.brandBuilderEditor.campaignItemMediasLoading,
		}),
		...mapGetters(['selectedDesignCampaignItem']),
	},
	methods: {
		...mapActions([
			'selectDesign',
			'selectAudienceType',
			'setDesignIndex',
			'completeVideoAction',
			'setRouteAllowed',
		]),
		selectCard(card, index) {
			if (
				this.$store.state.brandBuilderEditor.selectedMediaType ===
				MEDIA_ID.PRICING_FLYER
			) {
				this.setDesignIndex(0);
				this.selectDesign({
					item: card.item,
					template: this.$store.state.brandBuilderEditor.campaignItems[0],
				});
			} else if (
				this.$store.state.brandBuilderEditor.selectedMediaType ===
				MEDIA_ID.VIDEO
			) {
				this.setDesignIndex(index);
			} else {
				this.setDesignIndex(index);
				this.selectDesign(card);
			}
		},
		nextStep() {
			// TODO: If campaignItemMediasLoading = true, then disable the next button or present
			// a notification to the user letting them know that they can't proceed?
			if (!this.campaignItemMediasLoading) {
				switch (this.selectedMediaType) {
					case MEDIA_ID.FLYER:
					case MEDIA_ID.SOCIAL_MEDIA:
					case MEDIA_ID.EMAIL:
						this.$router.push({
							path: `/campaign-editor-workspace/${this.$route.params.campaignId}/images`,
						});
						break;
					case MEDIA_ID.VIDEO:
						this.$router.push({
							path: `/campaign-editor-workspace/${this.$route.params.campaignId}/branding`,
						});
						break;
					case MEDIA_ID.POWERPOINT:
						this.$router.push({
							path: `/campaign-editor-workspace/${this.$route.params.campaignId}/ppt-export`,
						});
						break;
					case MEDIA_ID.PRICING_FLYER:
						this.$router.push({
							path: `/campaign-editor-workspace/${this.$route.params.campaignId}/pricing`,
						});
						break;
					default:
					// No Default
				}
			}
		},
	},
	watch: {
		campaignItemMediasLoading(isLoading) {
			if (!isLoading) {
				this.setRouteAllowed({ route: 'additional', activated: true });
			}
		},
	},
	mounted() {
		/* TODO: Add Pricing Flyer condition since its only one that doesn't select audience?
		This seems be both here and in brandbuilder actions? Remove one. */
		if (this.selectedAudienceType === AUDIENCE_ID.BORROWER) {
			this.selectAudienceType(
				this.$store.state.brandBuilderEditor.audienceTypeArray[0],
			);
		}
		if (!this.campaignItemMediasLoading) {
			this.setRouteAllowed({ route: 'additional', activated: true });
		}
		this.completeVideoAction(null);
	},
};
</script>

<style lang="scss" scoped>
.design-column {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-content: space-around;

	@include sm {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		grid-gap: 15px;
	}

	@include mobile {
		grid-template-columns: 1fr;
	}
}

/* TODO: REMOVE - to support forced template */
.b360-large-image-radio {
	max-width: 100%;
	display: block;
	border-radius: $b360-border-radius-base;
}

.design {
	margin-bottom: 20px;
	border-radius: $b360-border-radius-medium;
	position: relative;
	display: block;
	.b360-fake-img-border {
		box-shadow: inset 0 0 0 $b360-border-width-thin $border-color-light;
		display: flex;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		border-radius: $b360-border-radius-base;
	}

	.custom-radio {
		position: absolute;
		top: 10px;
		right: 10px;
		z-index: 1;
	}
}

.design {
	&:focus,
	&:active,
	&:hover {
		.b360-fake-img-border {
			box-shadow: inset 0 0 0 $b360-border-width-medium $brand-teal;
		}

		.custom-radio {
			background-color: $brand-teal;
			box-shadow: inset 0 0 0 $b360-border-width-thin $brand-teal;
		}
	}
}

.selected {
	.b360-fake-img-border {
		box-shadow: inset 0 0 0 $b360-border-width-medium $brand-teal;
	}

	.custom-radio {
		background-color: $brand-teal;
		box-shadow: inset 0 0 0 $b360-border-width-thin $brand-teal;
	}
}

.checkbox {
	height: 18px;
	width: 18px;
	border-radius: $b360-border-radius-medium;
	box-shadow: inset 0 0 0 $b360-border-width-thin $border-color-light;
	background-color: $white;
	position: absolute;
	top: 10px;
	right: 10px;
	z-index: 1;

	&:checked {
		box-shadow: inset 0 0 0 $b360-border-width-medium $brand-teal;
		background-color: $brand-teal;
		color: $white;
		text-align: center;
		font-family: 'Font Awesome 5 Pro';

		&::after {
			display: inline-block;
			content: ' \2714';
		}
	}
}
</style>
